<section class="companion-section">
  <h4 class="companion-section__title">Type</h4>
  <mat-tab-group
    class="custom-tab-group custom-tab-group--selector"
    [selectedIndex]="simultaneousType.value"
    (selectedTabChange)="onSimultaneousTabChange($event)"
  >
    <mat-tab label="Count"></mat-tab>
    <mat-tab label="Sequence"></mat-tab>
  </mat-tab-group>
</section>

<section class="companion-section" *ngIf="showTimerControls">
  <div class="companion-field-grid">
    <mat-form-field appearance="outline">
      <mat-label>Delay (seconds)</mat-label>
      <mat-select [formControl]="_formGroup.controls.delay">
        <mat-option *ngFor="let option of delayOptions" [value]="option">
          {{ option | number: "1.1-1" }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Prompt</mat-label>
      <mat-select [formControl]="_formGroup.controls.timerPrompt">
        <mat-option *ngFor="let option of promptOptions" [value]="option">
          {{ option === 0 ? "Solid" : (option | number: "1.1-1") }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</section>

<section class="companion-section" *ngIf="showSensorSelection">
  <div class="flex items-center justify-between gap-4 mb-3">
    <h4 class="companion-section__title !mb-0">Sequence</h4>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      (click)="resetSensors()"
    >
      Reset
    </button>
  </div>
  <div class="companion-selection-panel flex flex-wrap gap-3">
    <span
      *ngIf="selectedSensors.length === 0"
      class="companion-selection-panel__empty"
    >
      No sensors selected
    </span>
    <button
      type="button"
      class="companion-sensor-chip"
      mat-mini-fab
      *ngFor="let sensor of selectedSensors.value; let i = index"
      [attr.aria-label]="'Remove sensor ' + sensor"
      (click)="removeSensor(i)"
    >
      {{ sensor }}
    </button>
  </div>
  <div class="companion-sensor-actions">
    <button
      type="button"
      mat-stroked-button
      *ngFor="let sensor of [1, 2, 3, 4, 5]"
      (click)="addSensor(sensor)"
    >
      {{ sensor }}
    </button>
  </div>
  <mat-error
    class="companion-error"
    *ngIf="_formGroup.touched && _formGroup.errors?.['sequenceRequired']"
  >
    Select at least one sensor for Sequence.
  </mat-error>
</section>

<section class="companion-section">
  <h4 class="companion-section__title">Companion Type</h4>
  <mat-tab-group
    class="custom-tab-group"
    [selectedIndex]="companionTypeTabIndex"
    (selectedTabChange)="onVisualTypeChange($event)"
  >
    <mat-tab label="Color">
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="colors"></ng-container>
      </ng-template>
    </mat-tab>
    <mat-tab label="Number">
      <ng-template matTabContent>
        <div class="companion-field-grid my-4">
          <mat-form-field appearance="outline">
            <mat-label>Count Increment By</mat-label>
            <mat-select [formControl]="_formGroup.controls.countIncrementBy">
              <mat-option
                *ngFor="let item of [].constructor(100); let i = index"
                [value]="i + 1"
              >
                {{ i + 1 }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Count Direction</mat-label>
            <mat-select [formControl]="_formGroup.controls.countDirection">
              <mat-option value="Ascending">Ascending</mat-option>
              <mat-option value="Descending">Descending</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Limit Low</mat-label>
            <input
              matInput
              type="number"
              step="1"
              min="1"
              max="999"
              [formControl]="_formGroup.controls.startValue"
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Limit High</mat-label>
            <input
              matInput
              type="number"
              step="1"
              min="2"
              max="999"
              [formControl]="_formGroup.controls.endValue"
            />
          </mat-form-field>
        </div>
        <mat-error
          *ngIf="
            _formGroup.touched && _formGroup.errors?.['invalidNumberRange']
          "
        >
          Limit High must be greater than Limit Low, and both values must be
          positive.
        </mat-error>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</section>

<ng-template #colors>
  <div class="flex flex-col gap-6 my-4">
    <div class="companion-color-picker">
      <div class="companion-section__title">React to</div>
      <div class="companion-color-grid">
        <button
          type="button"
          class="react-option"
          *ngFor="let color of colorOptions; let i = index"
          [ngClass]="color.className"
          [class.full-opacity]="react[i]"
          [attr.aria-label]="'React to ' + color.name"
          [attr.aria-pressed]="react[i]"
          [title]="color.name"
          (click)="setReact(i, false)"
          matRipple
        >
          <i class="material-icons react-overlay-icon" *ngIf="react[i]">
            done
          </i>
        </button>
      </div>
    </div>
    <div class="companion-color-picker">
      <div class="companion-section__title">Don't React to</div>
      <div class="companion-color-grid">
        <button
          type="button"
          class="react-option"
          *ngFor="let color of colorOptions; let i = index"
          [ngClass]="color.className"
          [class.full-opacity]="dontReact[i]"
          [attr.aria-label]="'Do not react to ' + color.name"
          [attr.aria-pressed]="dontReact[i]"
          [title]="color.name"
          (click)="setReact(i, true)"
          matRipple
        >
          <i class="material-icons react-overlay-icon" *ngIf="dontReact[i]">
            done
          </i>
        </button>
      </div>
    </div>
  </div>
  <mat-error
    class="companion-error"
    *ngIf="_formGroup.touched && _formGroup.errors?.['minReactTo']"
  >
    Select at least one React color.
  </mat-error>
  <mat-error
    class="companion-error"
    *ngIf="_formGroup.touched && _formGroup.errors?.['minDontReactTo']"
  >
    Select at least one Don't React color.
  </mat-error>
</ng-template>
